<template>
  <div class="user_tab">
    <el-card class="el-card-user-tab" type="border-card">
      <div class="user_hd">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            class="tab_item"
            label="基本资料"
            name="auditInformation"
            type="warning"
            :userData="userData"
          >
            <!-- <VInformation /> -->
          </el-tab-pane>
          <!-- <el-tab-pane class="tab_item" label="我的资质" name="qualifications" :userData="userData"> -->
          <!-- <VQualifications /> -->
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane class="tab_item" label="实名认证" name="authentication" :userData="userData"> -->
          <!-- <VAuthentication /> -->
          <!-- </el-tab-pane> -->
          <!-- <el-tab-pane class="tab_item" label="我的消息" name="news"> -->
            <!-- <VNews /> -->
          </el-tab-pane>
          <!--  <el-tab-pane class="tab_item" label="我的钱包" name="wallet">
          </el-tab-pane>
          <el-tab-pane class="tab_item" label="我的考勤" name="attendance">
          </el-tab-pane>-->

          <!--  <el-tab-pane class="tab_item" label="我的患者" name="patients">
          </el-tab-pane>-->

          <!-- <el-tab-pane class="tab_item" label="报告管理" name="reportManage">
          </el-tab-pane> -->
          <el-tab-pane
            class="tab_item"
            label="待审核处方"
            name="auditPrescription"
          >
          </el-tab-pane>
          <el-tab-pane class="tab_item" label="处方管理" name="prescription">
          </el-tab-pane>
          <el-tab-pane class="tab_item" label="设置" name="setup">
            <!-- <Setup /> -->
          </el-tab-pane>
        </el-tabs>
      </div>
      <router-view />
    </el-card>
    <Vfooter class="Vfooter" />
  </div>
</template>

<script>
import Vfooter from "@/components/footer/index.vue";
import utils from "@/utils";
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      activeName: "warning",
      isLoading: false,
      userData: {},
      userInfo: {},
    };
  },
  components: {
    Vfooter,
  },
  created() {
    this.getUrl();
  },
  watch: {
    // 更新页面所在位置，用于判断是前进页还是后退页
    $route(to, from) {
      var cur = to.path.split("/");
      this.activeName = cur[3];
    },
  },
  computed: {
    ...mapState(["status", "profileStep"]),
  },
  methods: {
    handleClick(tab, event) {
      var urlName = "";
      console.log(this.activeName);
      // switch (this.activeName) {
      //   case "":
      //     urlName = "";
      //     break;
      //   case "auditInformation":
      //     console.log("this.status:",this.status);
      //     console.log("this.profileStep:",this.profileStep);
      //     if (this.status === 0) {
      //       //待审核
      //       urlName = "/index/user/auditInformation/auditInfo";
      //       if (this.profileStep === 1 || this.profileStep === 2 || this.profileStep === 3){
      //         urlName = "/index/user/auditInformation/information";
      //       }
      //     }else if(this.status === 1){
      //       //审核通过
      //       urlName = "/index/user/auditInformation/information";
      //     }else if(this.status === -1) {
      //       //审核拒绝
      //       urlName = "/index/user/auditInformation/auditInfo";
      //     }
      //     break;
      //   default:
      //     urlName = "/index/user/" + this.activeName;
      //     break;
      // }
      // this.$router.push({
      //   path: urlName,
      // });
      if (this.activeName == "auditInformation") {
        this.$router.push({
          path: "/index/user/userInfo",
        });
      } else {
        this.$router.push({
          path: "/index/user/" + this.activeName,
        });
      }
    },
    /**
     * 用于解决刷新页面后，二级标题高亮与当前页面指向不同问题
     */
    getUrl() {
      let currentUrl = window.location.href;
      this.activeName = currentUrl.split("#")[1].split("/")[3];
      console.log("this.activeName", this.activeName);
    },
  },
};
</script>

<style lang="scss">
.el-tabs__item:hover {
  color: #fc9710;
}

.el-tabs__item.is-active {
  color: #fc9710;
}

.el-tabs__active-bar {
  background-color: #fc9710;
}
.user_tab {
  position: relative;
}
.user_tab .el-tabs__nav-scroll {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.user_tab .el-card__body {
  padding: 0px 20px 20px 20px;
}

.user_tab .el-tabs__item {
  flex: 1;
  text-align-last: justify;
  text-align: center;
  display: inline-block;
  letter-spacing: 3px !important;
}

.user_tab .el-card-user-tab {
  margin: 20px;
  min-height: 800px !important;
}
.user_tab .el-row {
  margin-top: 30px;
}
</style>
